import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import i18n, { applyAccountPreferredLanguage, hydrateLanguage } from './lib/i18n';
import ErrorBoundary from './components/ErrorBoundary';
import { SiteContentProvider } from './contexts/SiteContentContext';
import LiveChatProvider from './components/layout/LiveChatProvider';
import './aureus.css';

// FIXED: React 19 compatible root creation
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Create root only once - this was the bug!
const root = createRoot(rootElement);

// Open in English, keep a language chosen on this browser, then apply
// users.pref_language when a session exists. Country and browser language are not used.
void (async () => {
  try {
    await hydrateLanguage(null);
    await applyAccountPreferredLanguage();
  } catch (err) {
    console.warn('[i18n] hydrateLanguage failed:', err);
  }
})();
// Touch i18n to ensure the side-effect module isn't tree-shaken in any future bundler config
void i18n;

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <SiteContentProvider>
        <LiveChatProvider>
          <App />
        </LiveChatProvider>
      </SiteContentProvider>
    </ErrorBoundary>
  </React.StrictMode>
);